<template>
    <b-card>
        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>
        <b-alert variant="success" :show="showSuccessAlert">
            {{ alert }}
        </b-alert>
        <b-form @submit.prevent="setCashier">
            <b-form-group :label="$t('kkm.cashierCode')" label-cols-sm="3">
                <b-form-input v-model="formData.defaultCashierCode" required></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('kkm.cashierName')" label-cols-sm="3">
                <b-form-input v-model="formData.defaultCashierName" required></b-form-input>
            </b-form-group>
            <b-form-row class="justify-content-end mx-0">
                <b-button type="submit" variant="success" :disabled="isDisabled">
                    <save-icon title="" />&nbsp;{{ $t('general.save') }}
                </b-button>
            </b-form-row>
        </b-form>
    </b-card>
</template>

<script>
export default {
    name: 'SetCashierForm',
    props: {
        kkmId: Number
    },
    data () {
        return {
            showAlert: false,
            showSuccessAlert: false,
            alert: '',
            formData: {
                id: this.kkmId,
                defaultCashierCode: null,
                defaultCashierName: null
            }
        }
    },
    computed: {
        isDisabled: function () {
            return this.$store.getters.isLoading
        }
    },
    methods: {
        setCashier: function () {
            this.hideAlert()
            this.$request.sendRequest(this, this.$appConfig.apiUrls.kkm.setCashier,
                this.formData, result => {
                    this.alert = this.$i18n.t('kkm.cashierSetMessage')
                    this.showSuccessAlert = true
                }, this.displayAlert)
        },
        hideAlert: function () {
            this.showAlert = false
            this.showSuccessAlert = false
            this.alert = ''
        },
        displayAlert: function (errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`)
            this.showAlert = true
        }
    }
}
</script>
